/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConfigFieldReset
 */
export interface ConfigFieldReset {
  /**
   *
   * @type {string}
   * @memberof ConfigFieldReset
   */
  path: string;
  /**
   *
   * @type {string}
   * @memberof ConfigFieldReset
   */
  storedValue: string;
  /**
   *
   * @type {string}
   * @memberof ConfigFieldReset
   */
  resetTo: string;
}

/**
 * Check if a given object implements the ConfigFieldReset interface.
 */
export function instanceOfConfigFieldReset(
  value: object,
): value is ConfigFieldReset {
  if (!("path" in value) || value["path"] === undefined) return false;
  if (!("storedValue" in value) || value["storedValue"] === undefined)
    return false;
  if (!("resetTo" in value) || value["resetTo"] === undefined) return false;
  return true;
}

export function ConfigFieldResetFromJSON(json: any): ConfigFieldReset {
  return ConfigFieldResetFromJSONTyped(json, false);
}

export function ConfigFieldResetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConfigFieldReset {
  if (json == null) {
    return json;
  }
  return {
    path: json["path"],
    storedValue: json["storedValue"],
    resetTo: json["resetTo"],
  };
}

export function ConfigFieldResetToJSON(json: any): ConfigFieldReset {
  return ConfigFieldResetToJSONTyped(json, false);
}

export function ConfigFieldResetToJSONTyped(
  value?: ConfigFieldReset | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    path: value["path"],
    storedValue: value["storedValue"],
    resetTo: value["resetTo"],
  };
}
